import type { Resource } from '../../';
export const general_errors_renderAlerts_stackTrace: Resource = {"default":"Stack Trace"};
